import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AppComponent } from 'src/app/app.component';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { TextosService } from '../../services/textos/textos.service';
import Swal from 'sweetalert2';


declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-escolaridad-jub',
  templateUrl: '../../pages/escolaridad/escolaridad.component.html',
  styleUrls: ['../../pages/escolaridad/escolaridad.component.css']
})
export class EscolaridadJubComponent implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")

    diasDiferencia: any;
    cursos: any[]; postulantes: any[];
    textos: any;
    linkTexto: any;
    escolaridad = { afiliado: "", beneficiario: "", etapaEscolar: "", fechaCertificado: "", email: "",
                  archivo: { bytes: null, tipo: null }, archivoTest: null }
                  

    constructor(private router:Router, private escolaridadService:EscolaridadService,
                private productosService:ProductosService, private dialog: MatDialog,
                private postulacionesService: PostulacionesService,
                private appComponent: AppComponent,
                private afiliacionService: AfiliacionService,private textosService: TextosService) { }

    ngOnInit(): void
    {   
        if(localStorage.getItem("jubilado")!='true' && !localStorage.getItem("rol"))
        {
            this.appComponent.logoutJubilado();
        }
        if(this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO')
        {
            this.validaCarencia(2, localStorage.getItem("rutUsuario"))
        }
        

        let vm = this
        
        this.productosService.obtieneProductos().then
        (
            productos => productos[1].parametros.map( parametro => {
                if(parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_CERTIFICADO') {
                    vm.diasDiferencia = parametro.valor;
                }
            })
        )
        .catch ( error => console.log(error) );
        this.textosService.obtieneTextos()
        .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "ESCOLARIDAD")?.valor;             
        })
        .catch(error => {
        console.error('Error al obtener los textos:', error);
        });
    }

    ingresaAfiliado()
    {
        if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
            this.validarEstado(this.escolaridad.afiliado.split('.').join('').split('-')[0])
        }

        this.escolaridad.beneficiario = "", this.escolaridad.etapaEscolar = "", this.escolaridad.fechaCertificado = "",
        this.escolaridad.archivo.tipo = null, this.escolaridad.archivo.bytes = null, this.postulantes = [];

        if(Rut( this.escolaridad.afiliado))
        {
            var rut = this.escolaridad.afiliado.split('.').join('').split('-')[0]

            this.validaCarencia(2, rut)
        }
        else { this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger') }
    }

    validarEstado(rutAfiliado){
        this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
        ( 
            (response: any) => {
                if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                    || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                        || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                            console.log(response.estadoAfiliado)
                    this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                    this.router.navigate(['/index'])                 
                }
            }
        )
        .catch
        (
            error => {
            console.log('error :',error);
            }
        ) 
    }

    beneficiarioEtapaEscolar(beneficiario: any)
    {
        if(beneficiario == 'TITULAR')
        {
            this.cursos = ['MEDIA', 'TECNICO', 'UNIVERSITARIO']
        }
        else { this.cursos = ['KINDER', 'BASICA', 'MEDIA', 'TECNICO', 'UNIVERSITARIO'] }
    }

    seleccionaArchivo(event: any)
    {
        if(event.target.files.length > 0)
        {
            console.log(event.target.files[0].type)
            this.escolaridad.archivo.tipo = event.target.files[0].type

            let vm = this
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function() {
                vm.escolaridad.archivo.bytes = reader.result

                console.log(vm.escolaridad.archivo.bytes)
            }
        }
    }

    validaCarencia(producto: any, rut: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let vm = this

        this.productosService.cumpleCarencia(producto, rut).then ( () => vm.traePostulantes(rut) )
        .catch
        (
            error =>
            {
                Swal.close();
                if(error.status == 401 || error.status ==500)
                {
                    vm.openAlertDialog('El Usuario no cumple la carencia mínima para postular.', 'btn-danger')

                    vm.router.navigate(['/index'])
                }
                else
                {
                    vm.openAlertDialog('Afiliado no cumple con periodo de carencia', 'btn-danger')

                    vm.escolaridad.afiliado = ""
                }
            }
        )
    }

    traePostulantes(rut: any)
    {
        console.log(rut)
        var vm = this

        this.escolaridadService.traePostulantes(rut).then
        (
            (usuario: Usuario) =>
            {
                console.log(usuario)

                vm.escolaridad.email = usuario.email
                vm.nombreUsuario = usuario.nombres + ' ' + usuario.apellidoPaterno

                var usuariosPostulantes: Array<Usuario> = []

                usuariosPostulantes.push({ id: usuario.id, nombres: usuario.nombres,
                apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
                fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
                dv: usuario.dv, parentesco: 'TITULAR' })

                usuario.carga ? usuario.carga.forEach( carga =>
                {
                    carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)

                    usuariosPostulantes.push(carga)
                }) : null;

                vm.postulantes = usuariosPostulantes
                  Swal.close();
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                Swal.close();
                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-dark')
            }
        )
    }

    solicitar(form: NgForm)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let usuarioId: any, cargaId: any, titular: any;
        let tipoAfiliado = this.escolaridad.beneficiario.split('-')[2]
        let rut = this.escolaridad.beneficiario.split('-')[0]
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let fechaIngresada = new Date(this.escolaridad.fechaCertificado + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)


        if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
        {
            Swal.close();
            this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')

            return false
        }

        if(tipoAfiliado == 'TITULAR')
        {
            titular = true
            usuarioId = this.escolaridad.beneficiario.split('-')[1]
        }
        else
        {
            titular = false
            cargaId = this.escolaridad.beneficiario.split('-')[1]
        }

        if(!form.valid || !this.escolaridad.archivo)
        {
            Swal.close();
            this.openAlertDialog('Debe seleccionar un archivo', 'btn-dark')

            return false
        }

        if(this.escolaridad.archivo.tipo != "application/pdf" && this.escolaridad.archivo.tipo != "image/jpeg" &&
        this.escolaridad.archivo.tipo != "image/png" && this.escolaridad.archivo.tipo != "image/jpg")
        {
            Swal.close();
            this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')

            return false
        }

        delete this.escolaridad.beneficiario
        delete this.escolaridad.afiliado

        this.escolaridad.fechaCertificado = this.escolaridad.fechaCertificado.split('-')[2] + '-' +
                                            this.escolaridad.fechaCertificado.split('-')[1] + '-' +
                                            this.escolaridad.fechaCertificado.split('-')[0];

        console.log(+this.escolaridad)

        var vm = this

        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
        (
            response =>
            {
                console.log(response)
                Swal.close();
                vm.openAlertDialog('El rut ya tiene una solicitud de Escolaridad ingresada, favor revisar.', 'btn-danger')

                vm.escolaridad.archivo.bytes = null, vm.escolaridad.archivo.tipo = null

                form.reset()

                return
            }
        )
        .catch
        (
            () =>
            {
               
                    vm.escolaridadService.ingresaEscolaridad(vm.escolaridad, usuarioId, cargaId, vm.nombreUsuario,idUsuarioSesion).then
                    (
                        () =>
                        {
                            Swal.close();
                            vm.openAlertDialog('Solicitud ingresada exitosamente.', 'btn-success')
    
                            vm.escolaridad.archivo.bytes = null, vm.escolaridad.archivo.tipo = null
    
                            form.reset()
                        }
                    )
                    .catch( errorFinal =>
                    {   
                        console.log(errorFinal)

                        if(errorFinal.status == 500){
                            Swal.close();
                            vm.openAlertDialog('La fecha de certificado debe ser igual o mayor a la fecha de afiliación del usuario.', 'btn-danger')
                            return
                        } if(errorFinal.status == 403){
                            Swal.close();
                            vm.openAlertDialog('Afiliado no cumple con su periodo de carencia.', 'btn-danger')
                            return
                        }else{                            
                            Swal.close();
                            vm.openAlertDialog('No se ha ingresado la solicitud exitosamente.', 'btn-danger')
                
                        }
                    } )
           
            }
        )
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
